import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Card from 'shared/lib/components/Card';
import IconCircle from 'shared/lib/components/IconCircle';
import CardSectionHeading from '../CardSectionHeading';
import PolicyRow from '../PolicyRow';
import CardRowLink from '../CardRowLink';
import './PoliciesVerticalSummaryCard.css';

const propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  totalPolicies: PropTypes.number,
  recentPolicies: PropTypes.array,
  verticalCode: PropTypes.string,
};

const defaultProps = {
  icon: 'security',
  title: 'Policies',
  totalPolicies: 0,
  recentPolicies: [],
  verticalCode: null,
};

class PoliciesVerticalSummaryCard extends PureComponent {

  get recentPoliciesNodes() {
    return this.props.recentPolicies.map((policy) => (
      <PolicyRow
        key={policy.id}
        policyId={policy.id}
        createdAt={policy.created}
        verticalCode={policy.vertical_code}
        underwriter={policy.underwriter.name}
        details={policy.details}
        status={policy.status}
      />
    ));
  }

  render() {
    return (
      <Card className="PoliciesVerticalSummaryCard">
        <div className="PoliciesVerticalSummaryCard-header">
          <IconCircle
            className="PoliciesVerticalSummaryCard-icon"
            size={60}
            icon={this.props.icon}
          />
          <h2 className="PoliciesVerticalSummaryCard-heading">
            {this.props.title}
            <small className="PoliciesVerticalSummaryCard-totalCount">
              {this.props.totalPolicies} purchased
            </small>
          </h2>
        </div>
        <CardSectionHeading>
          Most recent
        </CardSectionHeading>
        {this.recentPoliciesNodes}
        <CardRowLink to={`/account/policies/${this.props.verticalCode}`}>
          Manage your policies
        </CardRowLink>
      </Card>
    );
  }
}

PoliciesVerticalSummaryCard.propTypes = propTypes;
PoliciesVerticalSummaryCard.defaultProps = defaultProps;

export default PoliciesVerticalSummaryCard;
